import React, { useState, useEffect, useRef } from "react";
import styles from "./verdadeDesafio.module.css";
import { useTranslation } from "react-i18next";
import Timer from "../../components/timer";
import { useSelector } from "react-redux";
import axios from "../../services/axios";
import { useLocation } from "react-router";

import { BackHeaderLeft } from "../../components/navigation/header";
import FlippableCard from "../../components/flippableCard";
import VerdadeDesafioModalCategoria from "../../components/verdadeDesafio/modalCategory";
import { StyledText } from "../../components/desafiosPicantes/game";

import {
  convertLanguageToField,
  getVerdadeDesafioCategoryImage,
} from "../../utils/functions";

// Card shuffle
const TIMINGS = {
  fade_in: 200 + 1300,
  sides_start: 300,
  sides_stay: 100,
  shuffle: 300,
  shuffle_amount: 3,
  sides_end: 400,
  center_reveal: 400,
  reveal_delay: 0,
};

function Card({ className = "", timings }) {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setFade(true);
    }, TIMINGS.fade_in + TIMINGS.sides_start + TIMINGS.sides_stay + TIMINGS.shuffle * TIMINGS.shuffle_amount);
  }, []);

  return (
    <FlippableCard
      className={`w-24 h-36 ${className}`}
      frontClassName="!bg-white"
      style={timings}
    >
      <div className="flex items-center justify-center h-full">
        <img
          className={`${
            fade ? "opacity-0" : "opacity-100"
          } transition-opacity duration-300`}
          src={require("../../assets/images/games/truthOrDare/cardIcon.png")}
          alt=""
        />
      </div>
    </FlippableCard>
  );
}

function Cards() {
  const [fade, setFade] = useState(false);

  const side_cards = {
    "--initial-fade": `${TIMINGS.fade_in}ms`,
    "--card-start": `${TIMINGS.sides_start}ms`,
    "--card-stay": `${TIMINGS.sides_stay}ms`,
    "--card-shuffle": `${TIMINGS.shuffle}ms`,
    "--card-shuffle-ammount": TIMINGS.shuffle_amount,
    "--card-end": `${TIMINGS.sides_end}ms`,
  };

  const center_card = {
    "--initial-fade": `${TIMINGS.fade_in}ms`,
    "--initial-stay": `${TIMINGS.sides_start + TIMINGS.sides_stay}ms`,
    "--card-shuffle": `${TIMINGS.shuffle}ms`,
    "--card-shuffle-ammount": TIMINGS.shuffle_amount,
    "--card-stay": `${TIMINGS.sides_stay}ms`,
    "--card-end": `${TIMINGS.center_reveal}ms`,
  };

  useEffect(() => {
    setTimeout(() => {
      setFade(true);
    }, 1000);
  }, []);

  return (
    <div
      className={`absolute transition-all duration-500 ${
        fade ? "opacity-100" : "opacity-0"
      }`}
    >
      <Card
        className={`${styles["card-animation-sides"]} ${styles["card-animation-left"]}`}
        timings={side_cards}
      />
      <Card
        className={`${styles["card-animation-sides"]} ${styles["card-animation-right"]}`}
        timings={side_cards}
      />
      <Card
        className={`${styles["card-animation-center"]}`}
        timings={center_card}
      />
    </div>
  );
}

const ScrollableCenteredContent = ({
  challenge,
  challengeField,
  player1,
  player2,
  truth,
  dare,
}) => {
  const scrollContainerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const container = scrollContainerRef.current;
    const content = contentRef.current;

    if (container && content) {
      const containerHeight = container.clientHeight;
      const contentHeight = content.clientHeight;

      if (contentHeight < containerHeight) {
        // Vertically center by adding top padding dynamically
        const offset = (containerHeight - contentHeight) / 2;
        content.style.marginTop = `${offset}px`;
      } else {
        // If scrollable, ensure we start at the top
        container.scrollTop = 0;
        content.style.marginTop = `0px`;
      }
    }
  }, [challenge, challengeField]); // Re-run when challenge content changes

  return (
    <div
      className={`absolute z-10 flex items-center w-full transition-all ${
        truth || dare ? "scale-100" : "scale-0"
      } duration-500 ${truth || dare ? "delay-500" : "delay-0"}`}
      style={{
        // height: "calc(var(--vh) * 100)",
        height: "100dvh",
      }}
    >
      <div
        ref={scrollContainerRef}
        className="flex flex-col h-1/2 w-full overflow-y-auto relative"
      >
        <div ref={contentRef} className="ps-5 pe-5 text-center">
          <StyledText
            className="!font-semibold text-2xl"
            phrase={
              challenge?.id_verdade_desafio ? challenge[challengeField] : ""
            }
            userName={player2.name}
            playerOneName={player1.name}
          />
        </div>
      </div>
    </div>
  );
};

export default function VerdadeDesafioGame() {
  const { t, i18n } = useTranslation();
  const categoryField = convertLanguageToField(i18n.language, "title");
  const challengeField = convertLanguageToField(i18n.language, "frase");
  const { category: defaultCategory } = useLocation().state;

  const [truth, setTruth] = useState(false);
  const [dare, setDare] = useState(false);
  const { player1: p1, player2: p2 } = useSelector((state) => state.players);

  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(defaultCategory || 0);
  const [challenge, setChallenge] = useState({});
  const [playedChallenges, setPlayedChallenges] = useState([]);
  const [player1, setPlayer1] = useState(p1);
  const [player2, setPlayer2] = useState(p2);
  const [cards, setCards] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    axios.get("/verdadeOuDesafio/getCategory").then((response) => {
      const { data } = response;
      setCategories(data);
    });
    animateCards();
  }, []);

  const handleTruth = () => {
    if (truth || dare) return;
    if (cards) return;
    getChallenge(1).then((result) => {
      setTruth(true);
      setDare(false);
    });
  };

  const handleDare = () => {
    if (truth || dare) return;
    if (cards) return;
    getChallenge(0).then((result) => {
      setTruth(false);
      setDare(true);
    });
  };

  const handleNext = () => {
    setTruth(false);
    setDare(false);
    setPlayer1(player2);
    setPlayer2(player1);
    animateCards();
  };

  const handleCategory = () => {
    setModalVisible(true);
  };

  const animateCards = () => {
    setCards(true);
    setTimeout(() => {
      setCards(false);
    }, TIMINGS.fade_in + TIMINGS.sides_start + TIMINGS.sides_stay + TIMINGS.shuffle * TIMINGS.shuffle_amount + TIMINGS.sides_stay + TIMINGS.sides_end - 100);
  };

  const getChallenge = async (type) => {
    try {
      const { data } = await axios.post("/verdadeOuDesafio/getChallenge", {
        player1: player1.gender,
        player2: player2.gender,
        category: categories[category].id_categoria,
        exclude: playedChallenges,
        type,
      });
      if (Array.isArray(data) && data.length) {
        setChallenge(data[0]);
        // Desativado, por hora
        // setPlayedChallenges([...playedChallenges, data[0].id_verdade_desafio]);
      } else {
        // No challenges
      }
    } catch (error) {}
  };

  return (
    <div className="container no-scroll mx-auto">
      <div className="absolute top-4 left-4 w-full z-20">
        <BackHeaderLeft />
      </div>
      {!(truth || dare) ? (
        <div className={`absolute w-full flex justify-center top-0`}>
          <button
            type="button"
            onClick={handleCategory}
            className={`${styles.category} touchable-opacity z-20`}
          >
            <img
              className="w-6 h-6 object-contain"
              src={getVerdadeDesafioCategoryImage(
                categories?.length ? categories[category]?.id_categoria : ""
              )}
              alt=""
            />
            <span className="font-bold text-2xl text-ellipsis ms-2">
              {categories?.length ? categories[category][categoryField] : ""}
            </span>
          </button>
        </div>
      ) : null}
      <div
        className={`${styles.background} ${truth ? styles.truth : ""} ${
          dare ? styles.dare : ""
        }`}
        style={{
          "--transition-delay": truth || dare ? "0s" : ".5s",
        }}
      >
        <div className={`${styles.backgroundTruth}`}></div>
        <div className={`${styles.backgroundDare}`}></div>
      </div>
      <div className="absolute flex w-full h-full">
        <img
          className={`absolute transition-all duration-500 h-full object-contain ${
            truth || dare ? "delay-500" : ""
          } -translate-x-full ${dare ? "!-translate-x-1/2" : ""}`}
          src={require("../../assets/images/games/truthOrDare/pink.png")}
          alt=""
        />
        <img
          className={`absolute transition-all duration-500 h-full object-contain ${
            truth || dare ? "delay-500" : ""
          } -translate-x-full ${truth ? "!-translate-x-1/2" : ""}`}
          src={require("../../assets/images/games/truthOrDare/purple.png")}
          alt=""
        />
      </div>
      <div
        className={`${styles.playerContainer} ${truth ? styles.truth : ""} ${
          dare ? styles.dare : ""
        }`}
        style={{ "--transition-delay": truth || dare ? "0s" : ".5s" }}
      >
        {cards ? (
          <Cards />
        ) : (
          <div className={styles.playerName}>
            <span className="text-black font-medium text-2xl">
              {player1.name}
            </span>
          </div>
        )}
      </div>
      <ScrollableCenteredContent
        challenge={challenge}
        challengeField={challengeField}
        player1={player1}
        player2={player2}
        truth={truth}
        dare={dare}
      />

      <div className="absolute flex justify-center w-full h-full">
        <button
          type="button"
          onClick={handleTruth}
          className={`${styles.button} ${styles.truth} ${
            truth ? styles.active : ""
          } ${dare ? styles.hide : ""} touchable-opacity z-20`}
          style={{ "--transition-delay": truth || dare ? "0s" : ".5s" }}
        >
          {truth ? player1.name : t("truth")}
        </button>
        <button
          type="button"
          onClick={handleDare}
          className={`${styles.button} ${styles.dare} ${
            truth ? styles.hide : ""
          } ${dare ? styles.active : ""} touchable-opacity z-20`}
          style={{ "--transition-delay": truth || dare ? "0s" : ".5s" }}
        >
          {dare ? player1.name : t("dare")}
        </button>
      </div>
      <div className="absolute z-20 flex flex-col justify-center w-full bottom-0">
        {challenge?.duracao ? (
          <div
            className={`${styles.timer} ${truth || dare ? styles.active : ""}`}
            style={{ "--transition-delay": truth || dare ? "1.5s" : "0s" }}
          >
            <Timer
              timer={challenge.duracao}
              color={truth ? "#8B0FAE" : "#D61A70"}
            />
          </div>
        ) : null}
        <button
          type="button"
          onClick={handleNext}
          className={`${styles.next} ${truth || dare ? styles.active : ""} ${
            truth ? styles.truth : styles.dare
          }`}
          style={{ "--transition-delay": truth || dare ? "1.5s" : "0s" }}
        >
          {t("next")}
        </button>
      </div>
      <VerdadeDesafioModalCategoria
        visible={modalVisible}
        setVisible={setModalVisible}
        categories={categories}
        selected={categories.length && categories[category]?.id_categoria}
        setSelected={setCategory}
      />
    </div>
  );
}
